import { useEffect } from 'react'
import { realtimeService } from '../api/services/realtime.service'
import { useAuth } from '../context/AuthContext'

/** Connects Echo after login; tears down on logout. Safe no-op without Pusher env keys. */
export function useRealtime(): void {
  const { isAuthenticated } = useAuth()

  useEffect(() => {
    if (!isAuthenticated) {
      realtimeService.disconnect()
      return
    }

    realtimeService.connect()

    return () => {
      realtimeService.disconnect()
    }
  }, [isAuthenticated])
}
